import React from 'react';
import {
    TableRow,
    TableCell,
    Typography,
    Dialog,
    DialogTitle,
    DialogContent
} from '@mui/material';
import { formatCurrency } from '../../../../utils/formatNumber';
import i18n from '../../../../i18n';
import cellConfig from './cellConfig';
import { isFieldVisibleByRole } from '../../../../utils/isFieldVisible';
class GridTotalRow extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dialogOpen: false,
            dialogData: {}
        };
    }
    calculateTotalRow = (data, head) => {
        const totalResult = {};
        // Calculate total for each column
        head.forEach((column) => {
            if (cellConfig[column.cell] && column.total) {
                totalResult[column.id] = cellConfig[column.cell].calculator(
                    data,
                    column.id
                );
            }
        });
        return totalResult;
    };

    handleCommissionsClick = (data, columnId) => {
        const details = data.reduce((acc, row) => {
            let items = [];
            try {
                items = JSON.parse(row[columnId] || '[]');
            } catch (e) {
                console.error('Error parsing JSON:', e);
            }
            if (!Array.isArray(items)) {
                items = [];
            }
            items.forEach((item) => {
                if (acc[item.name]) {
                    acc[item.name] += item.value;
                } else {
                    acc[item.name] = item.value;
                }
            });
            return acc;
        }, {});
        this.setState({ dialogOpen: true, dialogData: details });
    };

    handleCloseDialog = () => {
        this.setState({ dialogOpen: false, dialogData: [] });
    };

    renderDialog = () => {
        const { dialogOpen, dialogData } = this.state;
        return (
            <Dialog open={dialogOpen} onClose={this.handleCloseDialog}>
                <DialogTitle>{i18n.t('columns.commissionsTotal')}</DialogTitle>
                <DialogContent>
                    {Object.keys(dialogData).map((key) => (
                        <Typography key={key}>
                            {key}: {formatCurrency(dialogData[key])}
                        </Typography>
                    ))}
                </DialogContent>
            </Dialog>
        );
    };

    render() {
        const { head, role } = this.props;
        const visibleColumns = head.filter((column) => {
            if (!column.displayGrid) return false;
            const fieldKey = column.cell === 'SelectObject' ? column.object : column.id;
            return isFieldVisibleByRole(fieldKey, role);
        });
        const totalRow = this.calculateTotalRow(
            this.props.data,
            visibleColumns
        );

        const translatedTotal = (
            <Typography variant="body2">{i18n.t('columns.total')}</Typography>
        );
        return (
            <TableRow
                key="total"
                sx={{
                    backgroundColor: '#f4f6f8',
                    position: 'sticky',
                    zIndex: 1,
                    bottom: 0
                }}
            >
                <TableCell key="checkbox" padding="checkbox"></TableCell>
                {visibleColumns.map((column, i) => {
                    return (
                        <TableCell key={column.id} align="left">
                            {i === 0
                                ? translatedTotal
                                : column.total
                                    ? cellConfig[column.cell]
                                        ? cellConfig[column.cell].formatter(
                                            totalRow[column.id],
                                            () =>
                                                this.handleCommissionsClick(
                                                    this.props.data,
                                                    column.id
                                                )
                                        )
                                        : formatCurrency(totalRow[column.id])
                                    : ''}
                        </TableCell>
                    );
                })}
                <TableCell key="menu"></TableCell>
                {this.renderDialog()}
            </TableRow>
        );
    }
}

export default GridTotalRow;
